import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ss-logo',
  templateUrl: './logo.component.html',
  standalone: true,
  styleUrls: ['./logo.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoComponent {


}
